





import { defineComponent } from '@vue/composition-api';

const App = defineComponent({
});

export default App;
